import { useState } from "react";
import { LoansTableRow, Pagination } from "../../components";
import { useLocation } from "react-router-dom";

function Table({ loans, metadata, handlePagination }) {

    const location = useLocation();
    const { pathname } = location;
    const path = pathname.split("/")[1];

    const [currentPage, setCurrentPage] = useState(metadata?.currentPage || 1);
    const nPages = metadata?.totalPages;

    return (
        <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm">
            <div className="overflow-x-auto rounded-t-xl overflow-hidden">
                <table className='min-w-full'>
                    <thead>
                        <tr className='border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60'>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>Full Name</th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>Phone No.</th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>
                                {(path === "active-loans" || path === "completed-loans") ? `Type` : `Amount Req.`}
                            </th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>Amount Elig.</th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>
                                {path === "active-loans" ? `Disbursed on` : `Applied on`}
                            </th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>Stage</th>
                            <th scope="col" className='px-5 py-3.5 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide'>Action</th>
                        </tr>
                    </thead>

                    <tbody className='divide-y divide-gray-50 dark:divide-gray-700/50'>
                        {loans && loans?.length > 0 ? (
                            loans?.map(item => (
                                <LoansTableRow
                                    key={item?._id}
                                    item={item}
                                    path={path}
                                />
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className='px-5 py-12 text-center text-sm text-gray-400'>
                                    No loan applications found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {loans && loans?.length > 0 && (
                <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    length={metadata.totalCount}
                    handlePagination={handlePagination}
                />
            )}
        </div>
    );
}

export default Table;
